export default __webpack_public_path__ + "static/media/wavy-pepe.315fbe81.gif";